<template>
  <article :class="[ isAdmin ? '' : '', 'uk-comment', 'uk-padding-small']">

    <header class="uk-comment-header uk-grid-medium uk-flex-middle uk-margin-small-bottom" uk-grid>
      <div class="uk-width-auto" v-if="isAdmin">
        <img class="uk-comment-avatar" src="@/assets/images/logo.svg" width="80" alt="" uk-svg>
      </div>
      <div class="uk-width-expand">
        <h4 class="uk-comment-title uk-margin-remove">{{ getNameWithIdentifier }}</h4>
        <h4 class="uk-comment-meta uk-margin-remove-top">{{ date }} at {{ time }}</h4>
      </div>
    </header>

    <div class="uk-comment-body">
        <p>{{ message }}</p>
    </div>

  </article>
</template>

<script>
export default {
  name: 'TicketReply',
  props: ['isAdmin', 'fullName', 'date', 'time', 'message'],
  computed: {
    getNameWithIdentifier() {
      let name = this.isAdmin ? ( this.fullName + ' – Staff') : this.fullName
      return name
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

</style>
